import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';

import {
  getReplenishments,
  getReplenishmentsFail,
  getReplenishmentsSuccess,
  uploadReplenishmentUpdates,
  uploadReplenishmentUpdatesFailure,
  uploadReplenishmentUpdatesSuccess,
} from '../actions';
import { State } from '../models';
import { REPLENISHMENT_FEATURE_KEY } from '../state-config';

export interface OuterState {
  [REPLENISHMENT_FEATURE_KEY]: State;
}

export const initialState: State = {
  articles: null,
  uploading: false,
  loading: false,
  loaded: false,
};
const replenishmentReducer = createReducer(
  initialState,

  on(getReplenishments, (state) => ({
    ...state,
    loading: true,
    loaded: false,
  })),

  on(getReplenishmentsSuccess, (state, { articles }) => ({
    ...state,
    articles: Object.fromEntries(
      articles.map((article) => [article.productId, article]),
    ),
    loading: false,
    loaded: true,
  })),

  on(getReplenishmentsFail, (state) => ({
    ...state,
    loading: false,
  })),

  on(uploadReplenishmentUpdates, (state) => ({
    ...state,
    uploading: true,
  })),

  on(uploadReplenishmentUpdatesSuccess, (state, { articles }) => ({
    ...state,
    articles: Object.fromEntries(
      articles.map((article) => [article.productId, article]),
    ),
    uploading: false,
  })),

  on(uploadReplenishmentUpdatesFailure, (state) => ({
    ...state,
    uploading: false,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return replenishmentReducer(state, action);
}

export const selectReplenishmentState = createFeatureSelector<State>(
  REPLENISHMENT_FEATURE_KEY,
);
